{
  "_comment": "The one address the Share button sends and the QR code opens (Matt GO 2026-10-25 01:06). Kept out of the .ts files like src/ui/outboundLinks.json (src/smoke.test.ts forbids remote URLs there). No parameters, ever.",
  "url": "https://magia-li.pages.dev"
}
